import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as FileDetailsActions from './file-details.actions';
import * as FileDetailsSelectors from './file-details.selectors';
import { FileDetails } from './file-details.state';
import { FileStatus } from '../../core/models/file-status.model';

@Injectable({ providedIn: 'root' })
export class FileDetailsFacade {
  private readonly store = inject(Store);

  file$: Observable<FileDetails | null>;
  statuses$: Observable<FileStatus[]>;
  isLoading$: Observable<boolean>;
  isUpdating$: Observable<boolean>;
  isLoadingStatuses$: Observable<boolean>;
  error$: Observable<string | null>;

  constructor() {
    this.file$ = this.store.select(FileDetailsSelectors.selectFile);
    this.statuses$ = this.store.select(FileDetailsSelectors.selectStatuses);
    this.isLoading$ = this.store.select(FileDetailsSelectors.selectIsLoading);
    this.isUpdating$ = this.store.select(FileDetailsSelectors.selectIsUpdating);
    this.isLoadingStatuses$ = this.store.select(
      FileDetailsSelectors.selectIsLoadingStatuses
    );
    this.error$ = this.store.select(FileDetailsSelectors.selectError);
  }

  loadFileDetails(id: number) {
    this.store.dispatch(FileDetailsActions.loadFileDetails({ id }));
  }

  loadFileStatuses() {
    this.store.dispatch(FileDetailsActions.loadFileStatuses());
  }

  updateFileStatus(id: number, fileStatusId: number) {
    this.store.dispatch(
      FileDetailsActions.updateFileStatus({ id, fileStatusId })
    );
  }
}
